<template>
  <div class="container">
    <div class="stock-dashboard_header">
      <h3>{{ i18n.t('/StockDashboard/Title') }}</h3>
      <download-stock-button />
    </div>

    <div class="filter-dashboard">
      <div class="search-wrapper">
        <stock-dashboard-search v-model="searchQuery" @on-search="onSearch" />
      </div>
      <stock-dashboard-reservation
        v-model="reservationStatuses"
        class="reservation"
        @on-update-reservation-status="onChangeReservationStatus"
      />
      <form-checkbox id="national-stock" :title="i18n.t('/StockDashboard/ShowNationalStock')">
        <input
          id="national-stock"
          v-model="showNationalStock"
          type="checkbox"
          name="national-stock"
          @change="onChangeShowNationalStock"
        />
      </form-checkbox>
    </div>

    <stock-dashboard-table
      :reservation-statuses="reservationStatuses"
      @select-stock-car="selectStockCar"
    />

    <div class="loader-wrapper">
      <loader v-if="isLoading" />
    </div>

    <app-button v-if="!endReached" data-qa="show-more-stock-cars-button" @click="loadMore">
      {{ i18n.t('/StockDashboard/Table/LoadMore') }}
    </app-button>

    <stock-car-detail
      v-if="selectedStockCar"
      :stock-car-id="selectedStockCar.stockCarId"
      :title="selectedStockCar.title"
      @on-error="selectStockCar(null)"
      @on-cancel="selectStockCar(null)"
      @close="selectStockCar(null)"
    />
  </div>
</template>

<script>
import StoreConnector from '@/helpers/StoreConnector'
import StockCarDetail from '@/components/generic/presentational/organisms/stockCarDetail/StockCarDetail.vue'
import StockDashboardTable from '@/components/generic/presentational/organisms/stockDashboard/StockDashboardTable.vue'
import Loader from '@/components/generic/presentational/atoms/loader/Loader.vue'
import AppButton from '@/components/generic/presentational/atoms/appButton/AppButton.vue'
import StockDashboardReservation from '@/components/generic/presentational/organisms/stockDashboard/StockDashboardReservation.vue'
import StockDashboardSearch from '@/components/generic/presentational/organisms/stockDashboard/StockDashboardSearch.vue'
import FormCheckbox from '@/components/generic/presentational/atoms/formCheckbox/FormCheckbox.vue'
import stockCarsService from '@/services/stockCarsService.js'
import DownloadStockButton from '@/components/generic/presentational/molecules/downloadButton/DownloadStockButton.vue'
import ReservationStatus from '@/helpers/enums/reservationStatus'

export default {
  components: {
    StockDashboardTable,
    StockCarDetail,
    Loader,
    AppButton,
    StockDashboardReservation,
    FormCheckbox,
    StockDashboardSearch,
    DownloadStockButton,
  },
  data() {
    return {
      i18n: window.VUE_CLI_EXPORTS.plugins.i18n,
      isLoading: false,
      selectedStockCar: null,
      searchQuery: '',
      stockCars: [],
      currentPage: 1,
      pageSize: 5,
      reservationStatuses: [ReservationStatus.available],
      showNationalStock: false,
      endReached: false,
    }
  },
  computed: {
    searchReservationStatuses() {
      return this.reservationStatuses.filter((x) => x !== ReservationStatus.reservedSyntec)
    },
    syntecReserved() {
      return this.reservationStatuses.some((x) => x === ReservationStatus.reservedSyntec)
        ? true
        : null
    },
  },
  async created() {
    if (this.$route.query.search) {
      // external applications use this for searching directly
      this.searchQuery = this.$route.query.search
    }
    await this.fetchStockcars()
    StoreConnector.get('stockcars/isLoading', (data) => {
      this.isLoading = data
    })
  },
  methods: {
    selectStockCar(selectedStockCar) {
      this.selectedStockCar = selectedStockCar
    },
    async onSearch(query) {
      this.searchQuery = query
      this.currentPage = 1
      await this.fetchStockcars()
    },
    async onChangeShowNationalStock() {
      this.currentPage = 1
      this.fetchStockcars()
    },
    async onChangeReservationStatus(reservationStatuses) {
      this.reservationStatuses = reservationStatuses
      this.currentPage = 1
      this.fetchStockcars()
    },
    async loadMore() {
      this.currentPage++
      await this.fetchStockcars()
    },
    async fetchStockcars() {
      this.isLoading = true
      const search = this.searchQuery
      const reservationStatus = this.searchReservationStatuses
      const size = this.pageSize
      const page = this.currentPage
      const includeNationWide = this.showNationalStock
      const syntecReserved = this.syntecReserved
      this.endReached = false

      if (this.currentPage === 1) {
        await stockCarsService.resetStockCars()
      }

      const length = await stockCarsService.getStockCars(
        search,
        reservationStatus,
        size,
        page,
        includeNationWide,
        syntecReserved
      )
      if (length < size) this.endReached = true

      this.isLoading = false
    },
  },
}
</script>

<style lang="scss" scoped>
.container {
  @include center;
}

.filter-dashboard {
  display: grid;
  grid-auto-flow: column;
  -moz-column-gap: 1em;
  column-gap: 1em;
  align-items: center;
}

.reservation,
.search-wrapper {
  margin-right: 1em;
}

.search-wrapper {
  flex: 1 0 auto;
}

.loaderWrapper {
  display: grid;
}

.stock-dashboard_header {
  display: flex;
  justify-content: space-between;
}
</style>
